'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('./styles.js');

var Styles = _interopRequireWildcard(_styles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapFilter = function MapFilter(_ref) {
    var categories = _ref.categories,
        setCategory = _ref.setCategory,
        activeCategories = _ref.activeCategories,
        download = _ref.download;

    var allActive = '';

    if (activeCategories.length > 1) {
        allActive = 'is-active';

        categories.map(function (category) {
            category.is_active = false;
        });
    } else {
        categories.map(function (category) {
            if (category.id === activeCategories[0].id) {
                category.is_active = true;
            } else {
                category.is_active = false;
            }
        });
    }

    return _react2.default.createElement(
        Styles.MapFilter,
        null,
        _react2.default.createElement(
            'ul',
            null,
            categories.map(function (category) {
                return _react2.default.createElement(
                    Styles.MapFilterLi,
                    {
                        color: category.color,
                        key: category.id,
                        onClick: function onClick() {
                            return setCategory(category);
                        },
                        className: category.is_active ? 'is-active' : ''
                    },
                    _react2.default.createElement(
                        'span',
                        { className: 'radio' },
                        _react2.default.createElement('span', { className: 'radio-inner' })
                    ),
                    _react2.default.createElement('span', {
                        className: 'category-name',
                        dangerouslySetInnerHTML: { __html: category.title }
                    })
                );
            }),
            _react2.default.createElement(
                Styles.MapFilterLi,
                {
                    onClick: function onClick() {
                        return setCategory({ title: 'all' });
                    },
                    className: allActive,
                    isAll: true
                },
                _react2.default.createElement(
                    'span',
                    { className: 'radio all' },
                    _react2.default.createElement('span', { className: 'radio-inner' })
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'category-name' },
                    'All'
                )
            )
        ),
        download && _react2.default.createElement(
            'a',
            { href: download.url, target: '_blank', className: 'cta map-download-link' },
            _react2.default.createElement(
                'span',
                null,
                'Download Amenity Map'
            ),
            _react2.default.createElement('i', {
                dangerouslySetInnerHTML: { __html: '<svg xmlns="http://www.w3.org/2000/svg" width="9.894" height="13.182" viewBox="0 0 9.894 13.182">\n                    <g id="infobox-download-icon-g" data-name="Group 1364" transform="translate(-156.296 -874.573)">\n                      <path id="infobox-download-icon-path-1" data-name="infobox-download-icon-path-1" d="M265.107,1003.977l4.408,4.408,4.408-4.408" transform="translate(-108.085 -125.448)" fill="none" stroke="currentColor" stroke-width="1"/>\n                      <path id="infobox-download-icon-path-2" data-name="infobox-download-icon-path-2" d="M5002.567,835.5v8.16" transform="translate(-4841.138 39.073)" fill="none" stroke="currentColor" stroke-width="1"/>\n                      <path id="infobox-download-icon-path-3" data-name="infobox-download-icon-path-3" d="M5002.567,835.5v9.54" transform="translate(1001.337 -4115.313) rotate(90)" fill="none" stroke="currentColor" stroke-width="1"/>\n                    </g>\n                  </svg>' }
            })
        )
    );
};

MapFilter.propTypes = {
    activeCategories: _propTypes2.default.array,
    categories: _propTypes2.default.array,
    setCategory: _propTypes2.default.func,
    download: _propTypes2.default.any
};

exports.default = MapFilter;


// WEBPACK FOOTER //
// ./scripts/react/storelocator/MapFilter.js